export default {
  /**
   *
   * @param state
   * @param items
   */
  setStaffDashboardDailyAttendance(state, items) {
    console.log("Items", items);
    state.items = items;
  },

  /**
   *
   * @param state
   * @param pagination
   */
  setStaffDashboardDailyAttendancePagination(state, pagination) {
    console.log("Pagination", pagination);
    state.pagination = pagination;
  },

  /**
   *
   * @param state
   * @param currentPage
   */
  setStaffDashboardDailyAttendancePage(state, currentPage) {
    console.log("Current Page", currentPage);
    state.pagination.current_page = currentPage;
  },

  /**
   * Set filters.
   *
   * @param state
   * @param filters
   */
  setStaffDashboardDailyAttendanceFilters(state, filters) {
    state.filters = filters;
  },

  /**
   * Set is busy
   *
   * @param state
   * @param isBusy
   */
  setStaffDashboardDailyAttendanceBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};
